module.exports = __webpack_public_path__ + "media/navi/populife_return_key-ae034306.png";